import { render, staticRenderFns } from "./GameOnlineEditor.vue?vue&type=template&id=1d147e3a&scoped=true"
import script from "./GameOnlineEditor.vue?vue&type=script&lang=js"
export * from "./GameOnlineEditor.vue?vue&type=script&lang=js"
import style0 from "./GameOnlineEditor.vue?vue&type=style&index=0&id=1d147e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d147e3a",
  null
  
)

export default component.exports